import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {Component, ElementRef, ViewChild, Input, Output, EventEmitter, OnInit} from '@angular/core';
import {FormControl, FormBuilder, FormGroup} from '@angular/forms';
import {MatAutocompleteSelectedEvent, MatChipInputEvent} from '@angular/material';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';


export interface ItemGroup {  
  groupName:string;
  groupId:number;
  items:Array<{ id: number, name: string}>  
}



export const _filter = (opt: any[], value: string,items: any[]): any[] => {
	if (typeof value ==="string") {
		const filterValue = value.toLowerCase();

  	return opt.filter(item => {
  		var found =false
  		for (var i = 0; i < items.length; i++) {
  			if (items[i].id == item.id) {
  				found = true
  				break;
  			}
  		}
  		return item.name.toLowerCase().indexOf(filterValue) === 0 && !found
  	});
	} 
	return opt; 
};






@Component({
  selector: 'app-chips-autocomplet',
  templateUrl: './chips-autocomplet.component.html',
  styleUrls: ['./chips-autocomplet.component.css']
})
export class ChipsAutocompletComponent implements OnInit {
	visible = true;
	selectable = true;
	removable = true;
	addOnBlur = false;
	separatorKeysCodes: number[] = [ENTER, COMMA];	
	fruits: any[] = [];
	

	@ViewChild('fruitInput') fruitInput: ElementRef;

	@Input('items') itemGroups: ItemGroup[]
	@Input('placeholder') placeholder: string


	@Output() itemsSelected = new EventEmitter();	

	itemsForm: FormGroup = this.fb.group({
	    itemGroup: '',
	  });

	  itemsGroupOptions: Observable<ItemGroup[]>;

  constructor(private fb: FormBuilder) {
  	
  }

  ngOnInit() {
  	this.itemsGroupOptions = this.itemsForm.get('itemGroup')!.valueChanges
  	      .pipe(
  	        startWith(''),
  	        map(value => this._filterGroupItem(value))
  	      );  	      
  }


	private _filterGroupItem(value: string): ItemGroup[] {
	    if (value) {
	      return this.itemGroups
	        .map(group => ({groupName: group.groupName,groupId: group.groupId, items: _filter(group.items, value,this.fruits)}))
	        .filter(group => group.items.length > 0);
	    }

	    return this.itemGroups;
	  }


  remove(fruit): void {
    const index = this.fruits.indexOf(fruit);

    if (index >= 0) {
      this.fruits.splice(index, 1);
    }
    this.itemsSelected.emit(this.fruits);
  }

  selected(event: MatAutocompleteSelectedEvent): void {
  	var found =false
  	for (var i = 0; i < this.fruits.length; i++) {
  		if (this.fruits[i].id == event.option.value.id) {
  			found = true
  			break;
  		}
  	}
  	if (!found) {
  		this.fruits.push(event.option.value);  		
  		this.itemsSelected.emit(this.fruits);    
  	}
  	this.fruitInput.nativeElement.value = '';
    
  }

}